export default "__VITE_ASSET__DZyIYqZh__"